module.exports = "\n<div class=\"comp-popup\">\n  <popup-content :popup-key=\"popupKey\">Hello World</popup-content>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./assets/js/shared_frontend/components/popup/index.pug
// module id = 644
// module chunks = 5